import { render, staticRenderFns } from "./m13.vue?vue&type=template&id=c01d80be&scoped=true"
import script from "./m13.vue?vue&type=script&lang=js"
export * from "./m13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d80be",
  null
  
)

export default component.exports